module.exports = __webpack_public_path__ + "static/img/yomanet.d6cc67e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yomanet.png
// module id = 59
// module chunks = 2